module.exports = __webpack_public_path__ + "media/5.a2ed0998.mp3";